// Identidade do app do viajante (nome e tagline).

export const pt = {
  name: 'Serviquim Viagens',
  tagline: 'Gastos de viagem, mesmo sem sinal',
};

export const es: typeof pt = {
  name: 'Serviquim Viajes',
  tagline: 'Gastos de viaje, incluso sin señal',
};
